import { useLocation } from "react-router-dom";
import Header from "./Header";
import MenuMobile from './Mobile'
import ScrollButton from "./Scroll/useScroll";
import Footer from "./Footer";

const layoutConfig = {
  simpleLayoutRoutes: [
    "/painel/sign-in",
    "/painel/sign-admin",
    "/painel/dashboard",
  ],
};

export default function Layout({ children}) {
  const location = useLocation();
  const isSimpleLayout = layoutConfig.simpleLayoutRoutes.includes(location.pathname);

  if (isSimpleLayout) {
    return <>{children}</>;
  }

  return(
    <>
      <Header/>
      <MenuMobile/>
      {children}
      <ScrollButton/>
      <Footer/>
    </>
  );
}